import React, { Component } from 'react';
import withStyles from '@mui/styles/withStyles';
import IconButton from '@mui/material/IconButton';
import StarIcon from '../../component/icon/StarIcon';

class TaskStar extends Component {
    render() {
        const { disabled = null } = this.props;
        const checked = this.getValue();
        return (
            <IconButton
                disabled={disabled}
                className="task-star"
                onClick={() => this.onCheckChanged(!checked)}
                size="large"
            >
                <StarIcon filled={checked ? 'filled' : null} className="star-icon" />
            </IconButton>
        );
    }

    onCheckChanged(value) {
        const { onChange } = this.props;

        if (onChange) onChange(value);
    }

    getValue() {
        return this.props.value || false;
    }
}

export default withStyles({})(TaskStar);
